import LegalLayout, { Section } from "@/components/jobbkarta/LegalLayout";
import { CONTACT_EMAIL } from "@/components/jobbkarta/Footer";

const UPDATED = "12 oktober 2026";

export default function Terms() {
  return (
    <LegalLayout title="Användarvillkor" updated={UPDATED} testid="page-terms">
      <p>
        Dessa villkor gäller när du använder webbtjänsten Spontan. Genom att
        använda tjänsten godkänner du villkoren.
      </p>

      <Section heading="Om tjänsten">
        <p>
          Spontan. hjälper dig att hitta företag och lediga jobb på en karta och
          att skapa ansökningsmail med hjälp av AI. Informationen om företag och
          jobb hämtas från öppna källor (Arbetsförmedlingen och OpenStreetMap)
          och kan innehålla fel, vara ofullständig eller inaktuell.
        </p>
      </Section>

      <Section heading="Så får du använda tjänsten">
        <ul className="list-disc space-y-1 pl-5">
          <li>Tjänsten får användas för ditt personliga jobbsökande.</li>
          <li>
            Du ansvarar själv för innehållet i de mail du skickar och för att
            kontrollera uppgifter innan du kontaktar ett företag.
          </li>
          <li>
            Du får inte använda tjänsten för massutskick, skräppost, automatiserad
            skrapning eller på ett sätt som bryter mot lag eller mot tredje parts
            rättigheter.
          </li>
        </ul>
      </Section>

      <Section heading="AI-genererat innehåll">
        <p>
          Mail som skapas med AI är förslag. De kan innehålla felaktigheter och
          bör alltid läsas igenom och redigeras av dig innan de skickas. Du är
          ansvarig för det slutliga innehållet.
        </p>
      </Section>

      <Section heading="Köp">
        <p>
          Köp av den nedladdningsbara Uppföljningsguiden regleras av våra{" "}
          <a className="font-medium text-emerald-700 hover:underline" href="/kopvillkor">
            köpvillkor
          </a>
          .
        </p>
      </Section>

      <Section heading="Ansvarsbegränsning">
        <p>
          Tjänsten tillhandahålls i befintligt skick. Vi lämnar inga garantier för
          att informationen är korrekt eller att tjänsten alltid är tillgänglig,
          och ansvarar inte för skador som uppstår till följd av att du förlitar
          dig på informationen, i den utsträckning lagen tillåter.
        </p>
      </Section>

      <Section heading="Ändringar">
        <p>
          Vi kan uppdatera dessa villkor. Den senaste versionen finns alltid på
          den här sidan.
        </p>
      </Section>

      <Section heading="Kontakt">
        <p>
          Frågor? Mejla oss på{" "}
          <a className="font-medium text-emerald-700 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
